export default __webpack_public_path__ + "static/media/eye_n.874781a4.svg";